const bindAlternateToggle = () => {
  const alternateToggles = document.querySelectorAll( '.toggle-accordion' );

  if (!alternateToggles.length) {
    return;
  }

  alternateToggles.forEach( toggle => {

    toggle.addEventListener( 'click', event => {
      event.preventDefault();
      const accordion = toggle.closest( '.accordion' );

      // toggle the 'open' attribute
      if (accordion.hasAttribute( 'open' )) {
        accordion.removeAttribute( 'open' );
      } else {
        accordion.setAttribute( 'open', 'open' );
      }
    } );
  } );
}

const accordions = allAccordions => {
  bindAlternateToggle();
};

export default accordions;